module.exports = __webpack_public_path__ + "img/success_arrow.361980b1.svg";